// extracted by mini-css-extract-plugin
module.exports = {"slideHeader":"_3quVfRc7heFlhKHLpQiw3l","headlinePromoCode":"_2kVe29cOOMKW19P2hdTbLD"};